import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface ThankYouModalProps {
  onClose: () => void
}

const ThankYouModal = ({ onClose }: ThankYouModalProps) => {
  if (true) {
    ;[
      i18n.t('growth.sidepanel_chat.title'),
      i18n.t('growth.sidepanel_chat.learn_more'),
      i18n.t('growth.sidepanel_chat.success_text'),
      i18n.t('growth.sidepanel_chat.bullet_points.get_access'),
      i18n.t('growth.sidepanel_chat.bullet_points.not_additional_cost'),
      i18n.t('growth.sidepanel_chat.bullet_points.key_features'),
      i18n.t('growth.sidepanel_chat.bullet_points.early'),
      i18n.t('growth.sidepanel_chat.bullet_points.share_feedback'),
      i18n.t('growth.sidepanel_chat.bullet_points.shape_one'),
      i18n.t('growth.sidepanel_chat.waitlist.subtitle'),
      i18n.t('growth.sidepanel_chat.waitlist.description'),
      i18n.t('growth.sidepanel_chat.waitlist.until_date'),
      i18n.t('growth.sidepanel_chat.waitlist.join'),
      i18n.t('growth.sidepanel_chat.waitlist.to'),
      i18n.t('growth.sidepanel_chat.already_on_waitlist.subtitle'),
      i18n.t('growth.sidepanel_chat.already_on_waitlist.description'),
    ]
  }

  return (
    <Modal
      illustration="fireworks"
      title={i18n.t('upsell_page.thank_you_modal.title')}
      description={i18n.t('upsell_page.thank_you_modal.description')}
      onClose={onClose}
      footer={
        <Button type="primary" onClick={onClose}>
          {i18n.t('upsell_page.thank_you_modal.button')}
        </Button>
      }
    />
  )
}

export default ThankYouModal
